import { COMPONENT, register } from '!/repository'
import { GravyPaymentForm as GravyPaymentFormComponent } from './component/GravyPaymentForm'

export { GravyPaymentForm } from './ui'

// register `GravyPaymentFormComponent` componnt to use in skin (with name `GravyPaymentForm`)
register(GravyPaymentFormComponent, 'GravyPaymentForm', COMPONENT)
